var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"el-zoom-in-bottom"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.boardDisplayed),expression:"boardDisplayed"}],staticClass:"advertising_board",on:{"click":_vm.toLink}},[(!!_vm.banner.image)?_c('img',{staticClass:"advertising_img",attrs:{"src":_vm.banner.image,"alt":""}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }